export const iconFontAwesomeAnimalsWorm = (
	<i className="fa-solid fa-worm"></i>
);
